import React from 'react';
import RecommendCompanyCard from './RecommendCompanyCard';
import './recommendedCompanyItems.css';
import useRecommendedJobs from '../../../hooks/jobs/useRecommendedJobs';
import useTopRatedCompanies from '../../../hooks/company/useTopRatedCompanies';
import Slider from 'react-slick';
import Loading from '../../Shared/Loading/Loading';

const CompanyItems = () => {
  const { items, loading, error } = useTopRatedCompanies();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (loading) {
    return <><Loading/></>;
  }

  if (error) {
    return <div>Error loading jobs: {error.message}</div>;
  }

  // Ensure items is always an array before mapping
  const itemsArray = Array.isArray(items) ? items : [];

  if (itemsArray.length === 0) {
    return (
      <div className="recommended-company-items__container">
        <div className="recommended-company-items__title-container" id="recommended-company-title-container">
          <h2>EMPRESAS DESTACADAS</h2>
          <h3>DESCUBRE LOS MEJORES LUGARES</h3>
        </div>
        <div>No hay empresas disponibles en este momento.</div>
      </div>
    );
  }

  return (
    <div className="recommended-company-items__container">
      <div className="recommended-company-items__title-container" id="recommended-company-title-container">
        <h2>EMPRESAS DESTACADAS</h2>
        <h3>DESCUBRE LOS MEJORES LUGARES</h3>
      </div>
      
      <Slider {...settings}>
        {itemsArray.map((item) => (
          <div key={item.id}>
            <RecommendCompanyCard data={item} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CompanyItems;